import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { finalize, switchMap, take, tap } from 'rxjs';

import { TabSyncService } from '@auth/service/tab-sync.service';
import { DomainService } from '@common/service/domain.service';
import { SystemNotificationService } from '@common/service/system-notification.service';
import { UserService } from '@common/service/user.service';
import { ModuleStore } from '@modules/store/module.store';

@Injectable({
  providedIn: 'root',
})
export class EntityService {
  constructor(
    private httpClient: HttpClient,
    private userService: UserService,
    private moduleStore: ModuleStore,
    private tabSyncService: TabSyncService,
    private domainService: DomainService,
    private systemNotification: SystemNotificationService,
  ) {}

  switchEntity(entityId: string) {
    this.moduleStore.reset();

    this.systemNotification.showSpinner('Switching entity...');

    const params = new HttpParams().set('entity_id', entityId);
    return this.httpClient.get('/api/entity/switch', { params }).pipe(
      take(1),
      tap(() => {
        // Broadcast entity switch to all other tabs
        this.tabSyncService.broadcastEntitySwitch(entityId);
      }),
      switchMap(() => this.domainService.fetchDomainInfo()),
      switchMap(() => this.userService.getUserInfo(true)),
      finalize(() => {
        this.systemNotification.hide();
      }),
    );
  }
}
